module.exports = __webpack_public_path__ + "img/asuransi-mobil.08a863e8.svg";